---
fr:
  news_items:
    attachment: Pièce jointe
    categories:
      findings: Résultats
      landowner: Propriétaire foncier
      news: Actualités
      other: Autre
      project: Projet
      report: Rapport
      user_manual: Manuel de l'utilisateur
    community_access: Les utilisateurs peuvent voir les posts de la communauté
    community_warning: Les posts de la communauté seront visibles pour tou·te·s les utilisateurs·trices du portail
    create_post: Créer un post
    edit_post: Modifier le post
    filter_all: Tous les posts
    filter_category: Filtrer par catégorie
    filter_community: Posts de la communauté
    filter_internal: Posts internes
    filter_power_plant: Filtrer par centrale
    flash_delete_error: La suppression a échoué
    hydro_power_news: Actualités de l'hydroélectricité
    image_positions:
      left: Gauche
      right: Droite
      top: Haut
    landowner_access_info: Les propriétaires fonciers de cette entreprise et de ses filiales pourront voir ce post
    latest_posts: Derniers posts
    markdown_supported: Markdown pris en charge
    model_name: Élément de nouvelles
    portfolio_warning: Les filiales de cette entreprise pourront lire ce post
    publish: Créer un post
    save: Enregistrer le post
    search_placeholder: Rechercher par titre, contenu ou auteur...
    submit_draft: Enregistrer en tant que brouillon
    subsidiaries_warning: Ce post sera visible pour tous les utilisateurs portfolio et éditeurs des filiales des entreprises sélectionnées (l'accès des propriétaires fonciers nécessite une case à cocher séparée)
    unpublished_draft: Vous avez des brouillons non publiés
